import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Popover, Card, Row } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import Button from 'components/Button';
import { signOut, getUser } from 'services/auth';
import { getEnvValue } from 'config/enviroment';
import { duckUserProfile } from 'store/ducks/sefaz';
import { documentoMaskView } from 'utils/masks';
import { IS_TROCA_PERFIL, USUARIO_LOGADO_FAS } from 'utils/consts';
import { getTipoPerfil } from 'utils/funcaoPadrao';
import './resetStyle.css';
import * as S from './styles';

const pathCurrentUrl = window.location;
const oidcAuthority = getEnvValue('OIDC_AUTHORIY');

export const MenuUser = () => {
  const dispatch = useDispatch();

  const user = useSelector(state => state.sefaz.userProfile);
  const unitaryTests = useSelector(state => state.app.unitaryTests);

  React.useEffect(() => {
    if (unitaryTests) return;
    if (!user) {
      const userStorage = getUser();
      dispatch(duckUserProfile(userStorage));
    }
  }, [dispatch, user, unitaryTests]);

  const handleChangeProfile = () => {
    localStorage.clear();
    sessionStorage.clear();
    window.location.assign(`${oidcAuthority}/Perfil/Change?returnUrl=${pathCurrentUrl}`);
    localStorage.setItem(IS_TROCA_PERFIL, true);
    sessionStorage.removeItem(USUARIO_LOGADO_FAS);
  };

  const logOut = () => {
    signOut();
  };

  const contentPerfil = () => {
    return (
      <Card bordered={false} style={{ width: 400, backgroundColor: '#2784cf', borderRadius: '8px' }}>
        <S.TextoNome>{user?.name_representative}</S.TextoNome>
        <Row align="middle">
          <S.TextoDocumento>{documentoMaskView(user?.cpf_cnpj_representative)}</S.TextoDocumento>
          <S.TextoPerfil>{getTipoPerfil(user?.profile)}</S.TextoPerfil>
        </Row>
        <S.TextoDocumento>Representado - {documentoMaskView(user?.cpf_cnpj)}</S.TextoDocumento>
        <S.ButtonContainer>
          <Button text={'Trocar Perfil'} clickAction={() => handleChangeProfile()} />
          <Button text={'Sair'} clickAction={() => logOut()} />
        </S.ButtonContainer>
      </Card>
    );
  };

  return (
    <Popover placement="bottom" content={contentPerfil} trigger="click">
      <S.ContainerIcon>
        <S.IconButton>
          <UserOutlined style={{ color: 'var(--bottom-color-sefaz)' }} />
        </S.IconButton>
      </S.ContainerIcon>
    </Popover>
  );
};

export default MenuUser;
